/**
 * Dynamic DocType API client — Phase 3 low-code.
 *
 * Two layers:
 *   - dynamicDocTypesApi : manage DocType *definitions*
 *   - dynamicDocsApi      : CRUD for *records* of a given doctype
 */
import axios from 'axios';

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
const DEFS = `${BASE}/dynamic-doctypes`;
const DOCS = `${BASE}/doc`;

export const dynamicDocTypesApi = {
  list: (params = {}) => axios.get(DEFS, { params }),
  getByName: (name) => axios.get(`${DEFS}/by-name/${name}`),
  get: (id) => axios.get(`${DEFS}/${id}`),
  create: (payload) => axios.post(DEFS, payload),
  update: (id, payload) => axios.put(`${DEFS}/${id}`, payload),
  delete: (id, { dropData = false } = {}) =>
    axios.delete(`${DEFS}/${id}`, { params: { drop_data: dropData } }),
};

export const dynamicDocsApi = {
  list: (doctypeName, params = {}) =>
    axios.get(`${DOCS}/${doctypeName}`, { params }),
  get: (doctypeName, docId) => axios.get(`${DOCS}/${doctypeName}/${docId}`),
  linkOptions: (doctypeName) => axios.get(`${DOCS}/${doctypeName}/link-options`),
  create: (doctypeName, payload) => axios.post(`${DOCS}/${doctypeName}`, payload),
  update: (doctypeName, docId, payload) =>
    axios.put(`${DOCS}/${doctypeName}/${docId}`, payload),
  delete: (doctypeName, docId) =>
    axios.delete(`${DOCS}/${doctypeName}/${docId}`),
};

export default dynamicDocTypesApi;
